// Central per-page SEO metadata for DigitalBeej.
export const SITE_URL = "https://digitalbeej.in";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export const SEO = {
    home: {
        title: "DigitalBeej | Branding, Websites, AI & Performance Marketing",
        description:
            "Building brands from seed to scale through strategy, design, AI and measurable growth. Branding, websites, content, performance marketing and commerce growth.",
        path: "/",
    },
    services: {
        title: "Services — Branding, Web, Content, Performance & Commerce | DigitalBeej",
        description:
            "Five capabilities, one growth partner: brand & identity, websites & product, content & social, performance marketing, and commerce & AI growth — all under one roof.",
        path: "/services",
    },
    work: {
        title: "Work & Case Studies | DigitalBeej",
        description:
            "Selected work from seed to scale — branding, websites and growth campaigns for brands across hospitality, real estate, manufacturing, agriculture, food and SaaS.",
        path: "/work",
    },
    about: {
        title: "About — A Modern Creative Studio | DigitalBeej",
        description:
            "DigitalBeej is a founder-led creative and growth studio in Mumbai, combining strategy, design, AI and performance marketing to build brands from seed to scale.",
        path: "/about",
    },
    contact: {
        title: "Contact | DigitalBeej",
        description:
            "Tell us where your brand is — we'll come to the first call with a point of view. Chat on WhatsApp or send an enquiry; average reply under 2 hours.",
        path: "/contact",
    },
    privacy: {
        title: "Privacy Policy | DigitalBeej",
        description:
            "How DigitalBeej collects, uses and protects your data — contact form (Formspree), Google Analytics 4, Microsoft Clarity, cookies, data retention and your rights.",
        path: "/privacy",
    },
    terms: {
        title: "Terms & Conditions | DigitalBeej",
        description:
            "The terms that govern engagements with DigitalBeej — scope, fees, revisions, IP, confidentiality and jurisdiction.",
        path: "/terms",
    },
    notFound: {
        title: "Page Not Found | DigitalBeej",
        description:
            "The page you're looking for doesn't exist or may have moved. Head back to the DigitalBeej homepage.",
        path: "/404",
        noindex: true,
    },
};
